import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faUser,
  faDollarSign,
  faCog,
  faEnvelope,
  faListUl,
  faThLarge,
  faUserCircle,
  faImages,
  faVideo,
  faCheckSquare,
  faFileAlt,
  faPencil,
  faBlog,
  faBook,
  faLock,
  faSearch,
  faSadTear,
  faChevronDown,
  faTimes,
  faCheck,
  faCopy,
  faStar
} from "@fortawesome/free-solid-svg-icons";
import { faUser as farUser } from "@fortawesome/pro-regular-svg-icons";
import {
  faTwitterSquare,
  faFacebookSquare,
  faLinkedin
} from "@fortawesome/free-brands-svg-icons";

// Pro icons - these are the same as free icons but from pro packages
// If you have pro licenses, you can import from pro packages instead
import {
  faListUl as faProListUl,
  faThLarge as faProThLarge,
  faUserCircle as faProUserCircle,
  faImages as faProImages,
  faVideo as faProVideo,
  faCheckSquare as faProCheckSquare,
  faFileAlt as faProFileAlt,
  faPencil as faProPencil,
  faBlog as faProBlog,
  faBook as faProBook,
  faLock as faProLock,
  faSearch as faProSearch,
  faSadTear as faProSadTear,
  faChevronDown as faProChevronDown,
  faEnvelope as faProEnvelope,
  faTimes as faProTimes,
  faCheck as faProCheck,
  faCopy as faProCopy,
  faStar as faProStar
} from "@fortawesome/pro-solid-svg-icons";

import {
  faCheck as farProCheck,
  faTimes as farProTimes,
  faCopy as farProCopy,
  faStar as farProStar
} from "@fortawesome/pro-regular-svg-icons";

// Add icons to the library
library.add(
  // Free solid icons (fallback)
  faUser,
  faDollarSign,
  faCog,
  faEnvelope,
  faListUl,
  faThLarge,
  faUserCircle,
  faImages,
  faVideo,
  faCheckSquare,
  faFileAlt,
  faPencil,
  faBlog,
  faBook,
  faLock,
  faSearch,
  faSadTear,
  faChevronDown,
  faTimes,
  faCheck,
  faCopy,
  faStar,
  // Free regular icons
  farUser,
  // Free brand icons
  faTwitterSquare,
  faFacebookSquare,
  faLinkedin,
  // Pro solid icons (these will override free icons if available)
  faProListUl,
  faProThLarge,
  faProUserCircle,
  faProImages,
  faProVideo,
  faProCheckSquare,
  faProFileAlt,
  faProPencil,
  faProBlog,
  faProBook,
  faProLock,
  faProSearch,
  faProSadTear,
  faProChevronDown,
  faProEnvelope,
  faProTimes,
  faProCheck,
  faProCopy,
  faProStar,
  // Pro regular icons
  farProCheck,
  farProTimes,
  farProCopy,
  farProStar
);

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component("fa", FontAwesomeIcon);
  nuxtApp.vueApp.component("fa-icon", FontAwesomeIcon);
});
